module.exports = __webpack_public_path__ + "static/media/lakeland.8594fbbd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sections/lakeland.jpeg
// module id = 398
// module chunks = 0